// actionTypes.js
export const FETCH_LOGO_REQUEST = 'FETCH_LOGO_REQUEST';
export const FETCH_LOGO_SUCCESS = 'FETCH_LOGO_SUCCESS';
export const FETCH_LOGO_FAILURE = 'FETCH_LOGO_FAILURE';
